/* globals PLUG */
(function (LoginTemplate) {

    "use strict";

    let U;
    let loginContent;

    LoginTemplate.export = function () {
        U = PLUG.import("Utils");

        return Object.freeze({
            init
        });
    };

    function init() {
        const paramC = U.getUrlParam("c");
        const paramK = U.getUrlParam("k");
        loginContent = document.querySelector(".customer.login");
        if (paramC && paramK) {
            return ssoLogin(paramC, paramK);
        } else {
            loginContent.classList.remove("is-translucent");
            setupPasswordRecoveryForm();
        }
    }

    function ssoLogin(paramC, paramK) {
        const loadingStatus = document.getElementsByClassName("customer-login-loading-status")[0];
        loginContent.classList.add("is-hidden");
        loadingStatus.classList.remove("is-hidden");
        U.makeXmlRequest({
            url: `/a/helmlogin/get-data?c=${paramC}&k=${paramK}`,
            method: "GET"
        }, function done(data, reason) {
            if (reason) throw reason;

            data = JSON.parse(data);

            const form = document.getElementById("customer_login");
            const emailInput = document.getElementById("CustomerEmail");
            const passwordInput = document.getElementById("CustomerPassword");

            emailInput.value = data.a;
            passwordInput.value = data.b;

            U.submitForm({form: form, method: "post"}, function (data, err) {
                if (err) throw err;
                location.href = "/account/?plug_redirect=home";
            });
        });
    }

    function setupPasswordRecoveryForm() {
        const form = document.getElementById("password-recovery-form");
        const emailInput = document.getElementById("RecoverEmail");
        const ssoResetMessage = document.getElementById("plug-sso-reset-message");
        const recoverLink = document.getElementById("plug-recover-link");
        let blockFormSubmit = true;

        // We hide this at first to prevent users lacking javascript from submitting the
        // reset form and bypassing our non-sso verification process.
        recoverLink.classList.remove("hidden");

        form.addEventListener("submit", (e) => {
            if (blockFormSubmit) {
                e.preventDefault();
            }
        }, false);

        form.querySelectorAll("[type='submit']").forEach((btn) => {
            btn.addEventListener("click", (e) => {
                console.log("heard1");
                e.preventDefault();
                const email = emailInput.value;
                U.makeXmlRequest({
                    url: `/a/helmlogin/sso-status?e=${email}`,
                    method: "GET"
                }, function done(data, reason) {
                    if (reason) throw reason;

                    data = JSON.parse(data);
                    console.log({data});
                    if (data.status === true) {
                        ssoResetMessage.classList.remove("hidden");
                    } else {
                        blockFormSubmit = false;
                        form.submit();
                    }
                });
            });
        });
    }

})(PLUG.LoginTemplate = Object.create(null));
